// Crisp SVG flags (cross-platform — emoji flags don't render on Windows).
// All flags use a 60x40 (3:2) viewBox and fill their container.

const wrap = "block w-full h-full";

const Star = ({ cx, cy, r, fill = "#fff" }) => (
  <path
    fill={fill}
    transform={`translate(${cx} ${cy}) scale(${r / 5})`}
    d="M0 -5 L1.18 -1.62 4.76 -1.55 1.9 0.62 2.94 4.05 0 2 -2.94 4.05 -1.9 0.62 -4.76 -1.55 -1.18 -1.62 Z"
  />
);

const UnionJack = () => (
  <g>
    <rect width="60" height="40" fill="#012169" />
    <g stroke="#fff" strokeWidth="8">
      <line x1="0" y1="0" x2="60" y2="40" />
      <line x1="60" y1="0" x2="0" y2="40" />
    </g>
    <g stroke="#C8102E" strokeWidth="3">
      <line x1="0" y1="0" x2="60" y2="40" />
      <line x1="60" y1="0" x2="0" y2="40" />
    </g>
    <rect x="25" width="10" height="40" fill="#fff" />
    <rect y="15" width="60" height="10" fill="#fff" />
    <rect x="27" width="6" height="40" fill="#C8102E" />
    <rect y="17" width="60" height="6" fill="#C8102E" />
  </g>
);

export const FlagGB = () => (
  <svg viewBox="0 0 60 40" className={wrap} preserveAspectRatio="xMidYMid slice">
    <UnionJack />
  </svg>
);

export const FlagAU = () => (
  <svg viewBox="0 0 60 40" className={wrap} preserveAspectRatio="xMidYMid slice">
    <rect width="60" height="40" fill="#012169" />
    <g transform="scale(0.5)"><UnionJack /></g>
    <Star cx="15" cy="30" r="5.5" />
    <Star cx="50" cy="9" r="3" />
    <Star cx="57" cy="20" r="3" />
    <Star cx="50" cy="32" r="3" />
    <Star cx="43" cy="22" r="3" />
    <Star cx="49.5" cy="20.5" r="1.5" />
  </svg>
);

export const FlagNZ = () => (
  <svg viewBox="0 0 60 40" className={wrap} preserveAspectRatio="xMidYMid slice">
    <rect width="60" height="40" fill="#012169" />
    <g transform="scale(0.5)"><UnionJack /></g>
    {[
      [48, 10], [55, 21], [47, 32], [41, 21],
    ].map(([x, y], i) => (
      <g key={i}>
        <Star cx={x} cy={y} r="3.4" fill="#fff" />
        <Star cx={x} cy={y} r="2.1" fill="#C8102E" />
      </g>
    ))}
  </svg>
);

export const FlagFR = () => (
  <svg viewBox="0 0 60 40" className={wrap} preserveAspectRatio="xMidYMid slice">
    <rect width="20" height="40" fill="#0055A4" />
    <rect x="20" width="20" height="40" fill="#fff" />
    <rect x="40" width="20" height="40" fill="#EF4135" />
  </svg>
);

export const FlagDE = () => (
  <svg viewBox="0 0 60 40" className={wrap} preserveAspectRatio="xMidYMid slice">
    <rect width="60" height="13.33" fill="#111" />
    <rect y="13.33" width="60" height="13.33" fill="#DD0000" />
    <rect y="26.66" width="60" height="13.34" fill="#FFCE00" />
  </svg>
);

export const FlagUS = () => {
  const sh = 40 / 13;
  return (
    <svg viewBox="0 0 60 40" className={wrap} preserveAspectRatio="xMidYMid slice">
      <rect width="60" height="40" fill="#fff" />
      {[0, 2, 4, 6, 8, 10, 12].map((r) => (
        <rect key={r} y={r * sh} width="60" height={sh} fill="#B22234" />
      ))}
      <rect width="26" height={sh * 7} fill="#3C3B6E" />
      {Array.from({ length: 5 }).map((_, row) =>
        Array.from({ length: 6 }).map((_, col) => {
          const offset = row % 2 ? 3 : 0;
          const x = 2.5 + col * 4 + offset;
          if (x > 24) return null;
          return <circle key={`${row}-${col}`} cx={x} cy={2.4 + row * 4} r="0.9" fill="#fff" />;
        })
      )}
    </svg>
  );
};

export const FlagCA = () => (
  <svg viewBox="0 0 60 40" className={wrap} preserveAspectRatio="xMidYMid slice">
    <rect width="60" height="40" fill="#fff" />
    <rect width="15" height="40" fill="#D80621" />
    <rect x="45" width="15" height="40" fill="#D80621" />
    <g fill="#D80621">
      <path d="M30 7 L31.2 12 L34.5 11 L33.2 15 L37 14.3 L34.8 17.6 L39.5 19.8 L35.2 21 L36.3 24.2 L31.4 22.6 L31.9 31 L30 33 Z" />
      <path
        transform="translate(60,0) scale(-1,1)"
        d="M30 7 L31.2 12 L34.5 11 L33.2 15 L37 14.3 L34.8 17.6 L39.5 19.8 L35.2 21 L36.3 24.2 L31.4 22.6 L31.9 31 L30 33 Z"
      />
      <rect x="29.4" y="31" width="1.2" height="2.5" />
    </g>
  </svg>
);


export const FlagSG = () => (
  <svg viewBox="0 0 60 40" className={wrap} preserveAspectRatio="xMidYMid slice">
    <rect width="60" height="40" fill="#fff" />
    <rect width="60" height="20" fill="#EF3340" />
    {/* crescent */}
    <circle cx="14" cy="11" r="7" fill="#fff" />
    <circle cx="17.5" cy="11" r="6" fill="#EF3340" />
    {/* 5 stars in a pentagon */}
    {[
      [23, 7.6], [26.2, 10.0], [24.9, 13.9], [21.1, 13.9], [19.8, 10.0],
    ].map(([x, y], i) => <Star key={i} cx={x} cy={y} r="1.7" />)}
  </svg>
);

export const FlagMY = () => {
  const sh = 40 / 14;
  // 14-point star
  const cx = 21, cy = 12.5, ro = 4.3, ri = 1.95, n = 14;
  let d = "";
  for (let i = 0; i < n * 2; i++) {
    const r = i % 2 === 0 ? ro : ri;
    const a = (Math.PI / n) * i - Math.PI / 2;
    d += `${i === 0 ? "M" : "L"}${(cx + r * Math.cos(a)).toFixed(2)} ${(cy + r * Math.sin(a)).toFixed(2)} `;
  }
  d += "Z";
  return (
    <svg viewBox="0 0 60 40" className={wrap} preserveAspectRatio="xMidYMid slice">
      <rect width="60" height="40" fill="#fff" />
      {[0, 2, 4, 6, 8, 10, 12].map((r) => (
        <rect key={r} y={r * sh} width="60" height={sh} fill="#CC0001" />
      ))}
      <rect width="30" height={sh * 8} fill="#010066" />
      {/* crescent */}
      <circle cx="11.5" cy="12.5" r="5.6" fill="#FFCC00" />
      <circle cx="14" cy="12" r="4.9" fill="#010066" />
      {/* 14-point star */}
      <path d={d} fill="#FFCC00" />
    </svg>
  );
};
